import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ObjectType, TitleListType } from '@/@types/graphql-types';
import AdUnit from '@/components/AdUnit.vue';
import TitleDetailTitleInfoV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailTitleInfoV1.vue';
import TitleDetailQuickActionBarV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailQuickActionBarV1.vue';
import TitleDetailPosterWithInfo from '@/pages/titleDetailV1/v1/sidebar/TitleDetailPosterWithInfo.vue';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { QuickActionBarProps } from '@/interfaces/components/QuickActionBar';
import { TitleListName } from '@/interfaces/responses/title-list';
import { TitleContentType } from '@/interfaces/snowplow/title-context';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import { isTitleInList } from '@/helpers/title-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailTitleSidebarV1',
  props: {
    additionalContexts: { default: () => [] },
    title: null,
    titleContentType: { default: undefined },
    influencedSponsoredAd: { default: undefined },
    showPoster: { type: Boolean, default: true },
    showTitleInfo: { type: Boolean, default: true },
    showQuickAction: { type: Boolean, default: true },
    showAd: { type: Boolean, default: true },
    showChartInfo: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { additionalContexts: SnowplowContext[], title: TitleDetail, titleContentType: TitleContentType, influencedSponsoredAd: SponsoredAdFragment | undefined, showPoster: boolean, showTitleInfo: boolean, showQuickAction: boolean, showAd: boolean, showChartInfo: boolean };



const seenEpisodeCount = computed(() => {
	if (props.title.__typename === 'Show') return props.title.seenState.seenEpisodeCount;
	return 0;
});

const streamingChartInfo = computed(() => {
	return props.title?.streamingCharts?.edges?.[0].streamingChartInfo ?? null;
});

const quickActionBarProps = computed((): QuickActionBarProps => {
	const propsToReturn: QuickActionBarProps = {
		titleId: props.title.id,
		titleName: props.title.content.title,
		titleObjectId: props.title.objectId,
		titleObjectType: props.title.objectType,
		titleBackdrops: props.title.content.backdrops,
		titleContentType: props.titleContentType,
		titlePosterUrl: props.title.content.posterUrl ?? '',
		titleSeenEpisodeCount: seenEpisodeCount.value,
		isInWatchlist: isTitleInList(TitleListType.WatchNext, props.title),
		isInCustomList: isInCustomList.value,
		isTvShowTracked: isTvShowTracked.value,
		isInSeenList: isTitleInList(TitleListType.CaughtUp, props.title),
		isInLikeList: isTitleInList(TitleListType.Likelist, props.title),
		isInDislikeList: isTitleInList(TitleListType.Dislikelist, props.title),
		without: [TitleListName.SEENLIST],
		additionalContexts: props.additionalContexts,
		isTitleUpcoming: isTitleUpcoming.value,
		isTitleReleased: props.title.content.isReleased,
		likelistAdditions: interactions.value?.likelistAdditions || 0,
		dislikelistAdditions: interactions.value?.dislikelistAdditions || 0,
		jwVotes: interactions.value?.votesNumber || 0,
		influencedSponsoredAd: props.influencedSponsoredAd,
	};

	if (props.title.__typename === 'Season') {
		propsToReturn.seasonNumber = props.title.content.seasonNumber;
		propsToReturn.showDetails = {
			id: props.title.show?.id as string,
			objectType: props.title.show?.objectType as ObjectType,
			objectId: props.title.show?.objectId as number,
			title: props.title.show?.content.title,
			isReleased: props.title.show?.content.isReleased,
		};
	}

	return propsToReturn;
});

const showStreamingCharts = computed(() => {
	return !!streamingChartInfo.value && props.showChartInfo;
});

const interactions = computed(() => {
	if (props.title.__typename === 'Season' && (props.title.show?.totalSeasonCount as number) <= 1) {
		return null;
	}

	return props.title.content.interactions;
});

const isTitleUpcoming = computed(() => {
	return !props.title?.content.isReleased;
});

const isInCustomList = computed(() => {
	const customListEntries =
		props.title.__typename === 'Season' ? props.title.show?.customlistEntries : props.title.customlistEntries;

	return !!customListEntries?.length;
});

const isTvShowTracked = computed(() => {
	if (props.title.__typename === 'Season') {
		return !!props.title.show?.tvShowTrackingEntry?.createdAt;
	}

	return props.title.__typename === 'Show' ? !!props.title.tvShowTrackingEntry?.createdAt : false;
});

function removeAdClicked() {
	// TITLE_DETAIL_REDESIGN_NEW_BUYBOX
	// trackTitleDetailRedesignNewBuyBoxExp({ action: 'click', label: 'RemoveAds' });
}

return { __sfc: true,props, seenEpisodeCount, streamingChartInfo, quickActionBarProps, showStreamingCharts, interactions, isTitleUpcoming, isInCustomList, isTvShowTracked, removeAdClicked, AdUnit, TitleDetailTitleInfoV1, TitleDetailQuickActionBarV1, TitleDetailPosterWithInfo }
}

})